/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/




export const ALL_TIME_ZONES = [
  
    {"name":"Etc/GMT+12","displayName":"(-12:00) Etc/Gmt+12","utcOffsetSeconds":-43200},
  
    {"name":"Pacific/Pago_Pago","displayName":"(-11:00) Pacific/Pago Pago","utcOffsetSeconds":-39600},
  
    {"name":"Pacific/Midway","displayName":"(-11:00) Pacific/Midway","utcOffsetSeconds":-39600},
  
    {"name":"Pacific/Honolulu","displayName":"(-10:00) Pacific/Honolulu","utcOffsetSeconds":-36000},
  
    {"name":"America/Juneau","displayName":"(-09:00) America/Juneau","utcOffsetSeconds":-32400},
  
    {"name":"America/Los_Angeles","displayName":"(-08:00) America/Los Angeles","utcOffsetSeconds":-28800},
  
    {"name":"America/Tijuana","displayName":"(-08:00) America/Tijuana","utcOffsetSeconds":-28800},
  
    {"name":"America/Phoenix","displayName":"(-07:00) America/Phoenix","utcOffsetSeconds":-25200},
  
    {"name":"America/Mazatlan","displayName":"(-07:00) America/Mazatlan","utcOffsetSeconds":-25200},
  
    {"name":"America/Denver","displayName":"(-07:00) America/Denver","utcOffsetSeconds":-25200},
  
    {"name":"America/Guatemala","displayName":"(-06:00) America/Guatemala","utcOffsetSeconds":-21600},
  
    {"name":"America/Chicago","displayName":"(-06:00) America/Chicago","utcOffsetSeconds":-21600},
  
    {"name":"America/Chihuahua","displayName":"(-06:00) America/Chihuahua","utcOffsetSeconds":-21600},
  
    {"name":"America/Mexico_City","displayName":"(-06:00) America/Mexico City","utcOffsetSeconds":-21600},
  
    {"name":"America/Monterrey","displayName":"(-06:00) America/Monterrey","utcOffsetSeconds":-21600},
  
    {"name":"America/Regina","displayName":"(-06:00) America/Regina","utcOffsetSeconds":-21600},
  
    {"name":"America/Bogota","displayName":"(-05:00) America/Bogota","utcOffsetSeconds":-18000},
  
    {"name":"America/New_York","displayName":"(-05:00) America/New York","utcOffsetSeconds":-18000},
  
    {"name":"America/Indiana/Indianapolis","displayName":"(-05:00) America/Indiana/Indianapolis","utcOffsetSeconds":-18000},
  
    {"name":"America/Lima","displayName":"(-05:00) America/Lima","utcOffsetSeconds":-18000},
  
    {"name":"America/Halifax","displayName":"(-04:00) America/Halifax","utcOffsetSeconds":-14400},
  
    {"name":"America/Caracas","displayName":"(-04:00) America/Caracas","utcOffsetSeconds":-14400},
  
    {"name":"America/Guyana","displayName":"(-04:00) America/Guyana","utcOffsetSeconds":-14400},
  
    {"name":"America/La_Paz","displayName":"(-04:00) America/La Paz","utcOffsetSeconds":-14400},
  
    {"name":"America/Puerto_Rico","displayName":"(-04:00) America/Puerto Rico","utcOffsetSeconds":-14400},
  
    {"name":"America/Santiago","displayName":"(-03:00) America/Santiago","utcOffsetSeconds":-10800},
  
    {"name":"America/St_Johns","displayName":"(-03:30) America/St Johns","utcOffsetSeconds":-12600},
  
    {"name":"America/Asuncion","displayName":"(-03:00) America/Asuncion","utcOffsetSeconds":-10800},
  
    {"name":"America/Sao_Paulo","displayName":"(-03:00) America/Sao Paulo","utcOffsetSeconds":-10800},
  
    {"name":"America/Argentina/Buenos_Aires","displayName":"(-03:00) America/Argentina/Buenos Aires","utcOffsetSeconds":-10800},
  
    {"name":"America/Montevideo","displayName":"(-03:00) America/Montevideo","utcOffsetSeconds":-10800},
  
    {"name":"America/Nuuk","displayName":"(-02:00) America/Nuuk","utcOffsetSeconds":-7200},
  
    {"name":"Atlantic/South_Georgia","displayName":"(-02:00) Atlantic/South Georgia","utcOffsetSeconds":-7200},
  
    {"name":"Atlantic/Azores","displayName":"(-01:00) Atlantic/Azores","utcOffsetSeconds":-3600},
  
    {"name":"Atlantic/Cape_Verde","displayName":"(-01:00) Atlantic/Cape Verde","utcOffsetSeconds":-3600},
  
    {"name":"Africa/Casablanca","displayName":"(+00:00) Africa/Casablanca","utcOffsetSeconds":0},
  
    {"name":"Europe/London","displayName":"(+00:00) Europe/London","utcOffsetSeconds":0},
  
    {"name":"Europe/Lisbon","displayName":"(+00:00) Europe/Lisbon","utcOffsetSeconds":0},
  
    {"name":"Africa/Monrovia","displayName":"(+00:00) Africa/Monrovia","utcOffsetSeconds":0},
  
    {"name":"Etc/UTC","displayName":"(+00:00) Etc/Utc","utcOffsetSeconds":0},
  
    {"name":"Europe/Amsterdam","displayName":"(+01:00) Europe/Amsterdam","utcOffsetSeconds":3600},
  
    {"name":"Europe/Belgrade","displayName":"(+01:00) Europe/Belgrade","utcOffsetSeconds":3600},
  
    {"name":"Europe/Berlin","displayName":"(+01:00) Europe/Berlin","utcOffsetSeconds":3600},
  
    {"name":"Europe/Zurich","displayName":"(+01:00) Europe/Zurich","utcOffsetSeconds":3600},
  
    {"name":"Europe/Bratislava","displayName":"(+01:00) Europe/Bratislava","utcOffsetSeconds":3600},
  
    {"name":"Europe/Brussels","displayName":"(+01:00) Europe/Brussels","utcOffsetSeconds":3600},
  
    {"name":"Europe/Budapest","displayName":"(+01:00) Europe/Budapest","utcOffsetSeconds":3600},
  
    {"name":"Europe/Copenhagen","displayName":"(+01:00) Europe/Copenhagen","utcOffsetSeconds":3600},
  
    {"name":"Europe/Dublin","displayName":"(+00:00) Europe/Dublin","utcOffsetSeconds":0},
  
    {"name":"Europe/Ljubljana","displayName":"(+01:00) Europe/Ljubljana","utcOffsetSeconds":3600},
  
    {"name":"Europe/Madrid","displayName":"(+01:00) Europe/Madrid","utcOffsetSeconds":3600},
  
    {"name":"Europe/Paris","displayName":"(+01:00) Europe/Paris","utcOffsetSeconds":3600},
  
    {"name":"Europe/Prague","displayName":"(+01:00) Europe/Prague","utcOffsetSeconds":3600},
  
    {"name":"Europe/Rome","displayName":"(+01:00) Europe/Rome","utcOffsetSeconds":3600},
  
    {"name":"Europe/Sarajevo","displayName":"(+01:00) Europe/Sarajevo","utcOffsetSeconds":3600},
  
    {"name":"Europe/Skopje","displayName":"(+01:00) Europe/Skopje","utcOffsetSeconds":3600},
  
    {"name":"Europe/Stockholm","displayName":"(+01:00) Europe/Stockholm","utcOffsetSeconds":3600},
  
    {"name":"Europe/Vienna","displayName":"(+01:00) Europe/Vienna","utcOffsetSeconds":3600},
  
    {"name":"Europe/Warsaw","displayName":"(+01:00) Europe/Warsaw","utcOffsetSeconds":3600},
  
    {"name":"Africa/Algiers","displayName":"(+01:00) Africa/Algiers","utcOffsetSeconds":3600},
  
    {"name":"Europe/Zagreb","displayName":"(+01:00) Europe/Zagreb","utcOffsetSeconds":3600},
  
    {"name":"Europe/Athens","displayName":"(+02:00) Europe/Athens","utcOffsetSeconds":7200},
  
    {"name":"Europe/Bucharest","displayName":"(+02:00) Europe/Bucharest","utcOffsetSeconds":7200},
  
    {"name":"Africa/Cairo","displayName":"(+02:00) Africa/Cairo","utcOffsetSeconds":7200},
  
    {"name":"Africa/Harare","displayName":"(+02:00) Africa/Harare","utcOffsetSeconds":7200},
  
    {"name":"Europe/Helsinki","displayName":"(+02:00) Europe/Helsinki","utcOffsetSeconds":7200},
  
    {"name":"Asia/Jerusalem","displayName":"(+02:00) Asia/Jerusalem","utcOffsetSeconds":7200},
  
    {"name":"Europe/Kaliningrad","displayName":"(+02:00) Europe/Kaliningrad","utcOffsetSeconds":7200},
  
    {"name":"Europe/Kyiv","displayName":"(+02:00) Europe/Kyiv","utcOffsetSeconds":7200},
  
    {"name":"Africa/Johannesburg","displayName":"(+02:00) Africa/Johannesburg","utcOffsetSeconds":7200},
  
    {"name":"Europe/Riga","displayName":"(+02:00) Europe/Riga","utcOffsetSeconds":7200},
  
    {"name":"Europe/Sofia","displayName":"(+02:00) Europe/Sofia","utcOffsetSeconds":7200},
  
    {"name":"Europe/Tallinn","displayName":"(+02:00) Europe/Tallinn","utcOffsetSeconds":7200},
  
    {"name":"Europe/Vilnius","displayName":"(+02:00) Europe/Vilnius","utcOffsetSeconds":7200},
  
    {"name":"Asia/Baghdad","displayName":"(+03:00) Asia/Baghdad","utcOffsetSeconds":10800},
  
    {"name":"Europe/Istanbul","displayName":"(+03:00) Europe/Istanbul","utcOffsetSeconds":10800},
  
    {"name":"Asia/Kuwait","displayName":"(+03:00) Asia/Kuwait","utcOffsetSeconds":10800},
  
    {"name":"Europe/Minsk","displayName":"(+03:00) Europe/Minsk","utcOffsetSeconds":10800},
  
    {"name":"Europe/Moscow","displayName":"(+03:00) Europe/Moscow","utcOffsetSeconds":10800},
  
    {"name":"Africa/Nairobi","displayName":"(+03:00) Africa/Nairobi","utcOffsetSeconds":10800},
  
    {"name":"Asia/Riyadh","displayName":"(+03:00) Asia/Riyadh","utcOffsetSeconds":10800},
  
    {"name":"Europe/Volgograd","displayName":"(+03:00) Europe/Volgograd","utcOffsetSeconds":10800},
  
    {"name":"Asia/Tehran","displayName":"(+03:30) Asia/Tehran","utcOffsetSeconds":12600},
  
    {"name":"Asia/Muscat","displayName":"(+04:00) Asia/Muscat","utcOffsetSeconds":14400},
  
    {"name":"Asia/Baku","displayName":"(+04:00) Asia/Baku","utcOffsetSeconds":14400},
  
    {"name":"Europe/Samara","displayName":"(+04:00) Europe/Samara","utcOffsetSeconds":14400},
  
    {"name":"Asia/Tbilisi","displayName":"(+04:00) Asia/Tbilisi","utcOffsetSeconds":14400},
  
    {"name":"Asia/Yerevan","displayName":"(+04:00) Asia/Yerevan","utcOffsetSeconds":14400},
  
    {"name":"Asia/Kabul","displayName":"(+04:30) Asia/Kabul","utcOffsetSeconds":16200},
  
    {"name":"Asia/Almaty","displayName":"(+05:00) Asia/Almaty","utcOffsetSeconds":18000},
  
    {"name":"Asia/Yekaterinburg","displayName":"(+05:00) Asia/Yekaterinburg","utcOffsetSeconds":18000},
  
    {"name":"Asia/Karachi","displayName":"(+05:00) Asia/Karachi","utcOffsetSeconds":18000},
  
    {"name":"Asia/Tashkent","displayName":"(+05:00) Asia/Tashkent","utcOffsetSeconds":18000},
  
    {"name":"Asia/Kolkata","displayName":"(+05:30) Asia/Kolkata","utcOffsetSeconds":19800},
  
    {"name":"Asia/Colombo","displayName":"(+05:30) Asia/Colombo","utcOffsetSeconds":19800},
  
    {"name":"Asia/Kathmandu","displayName":"(+05:45) Asia/Kathmandu","utcOffsetSeconds":20700},
  
    {"name":"Asia/Dhaka","displayName":"(+06:00) Asia/Dhaka","utcOffsetSeconds":21600},
  
    {"name":"Asia/Urumqi","displayName":"(+06:00) Asia/Urumqi","utcOffsetSeconds":21600},
  
    {"name":"Asia/Yangon","displayName":"(+06:30) Asia/Yangon","utcOffsetSeconds":23400},
  
    {"name":"Asia/Bangkok","displayName":"(+07:00) Asia/Bangkok","utcOffsetSeconds":25200},
  
    {"name":"Asia/Jakarta","displayName":"(+07:00) Asia/Jakarta","utcOffsetSeconds":25200},
  
    {"name":"Asia/Krasnoyarsk","displayName":"(+07:00) Asia/Krasnoyarsk","utcOffsetSeconds":25200},
  
    {"name":"Asia/Novosibirsk","displayName":"(+07:00) Asia/Novosibirsk","utcOffsetSeconds":25200},
  
    {"name":"Asia/Shanghai","displayName":"(+08:00) Asia/Shanghai","utcOffsetSeconds":28800},
  
    {"name":"Asia/Chongqing","displayName":"(+08:00) Asia/Chongqing","utcOffsetSeconds":28800},
  
    {"name":"Asia/Hong_Kong","displayName":"(+08:00) Asia/Hong Kong","utcOffsetSeconds":28800},
  
    {"name":"Asia/Irkutsk","displayName":"(+08:00) Asia/Irkutsk","utcOffsetSeconds":28800},
  
    {"name":"Asia/Kuala_Lumpur","displayName":"(+08:00) Asia/Kuala Lumpur","utcOffsetSeconds":28800},
  
    {"name":"Australia/Perth","displayName":"(+08:00) Australia/Perth","utcOffsetSeconds":28800},
  
    {"name":"Asia/Singapore","displayName":"(+08:00) Asia/Singapore","utcOffsetSeconds":28800},
  
    {"name":"Asia/Taipei","displayName":"(+08:00) Asia/Taipei","utcOffsetSeconds":28800},
  
    {"name":"Asia/Ulaanbaatar","displayName":"(+08:00) Asia/Ulaanbaatar","utcOffsetSeconds":28800},
  
    {"name":"Asia/Tokyo","displayName":"(+09:00) Asia/Tokyo","utcOffsetSeconds":32400},
  
    {"name":"Asia/Seoul","displayName":"(+09:00) Asia/Seoul","utcOffsetSeconds":32400},
  
    {"name":"Asia/Yakutsk","displayName":"(+09:00) Asia/Yakutsk","utcOffsetSeconds":32400},
  
    {"name":"Australia/Adelaide","displayName":"(+10:30) Australia/Adelaide","utcOffsetSeconds":37800},
  
    {"name":"Australia/Darwin","displayName":"(+09:30) Australia/Darwin","utcOffsetSeconds":34200},
  
    {"name":"Australia/Brisbane","displayName":"(+10:00) Australia/Brisbane","utcOffsetSeconds":36000},
  
    {"name":"Australia/Canberra","displayName":"(+11:00) Australia/Canberra","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Guam","displayName":"(+10:00) Pacific/Guam","utcOffsetSeconds":36000},
  
    {"name":"Australia/Hobart","displayName":"(+11:00) Australia/Hobart","utcOffsetSeconds":39600},
  
    {"name":"Australia/Melbourne","displayName":"(+11:00) Australia/Melbourne","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Port_Moresby","displayName":"(+10:00) Pacific/Port Moresby","utcOffsetSeconds":36000},
  
    {"name":"Australia/Sydney","displayName":"(+11:00) Australia/Sydney","utcOffsetSeconds":39600},
  
    {"name":"Asia/Vladivostok","displayName":"(+10:00) Asia/Vladivostok","utcOffsetSeconds":36000},
  
    {"name":"Asia/Magadan","displayName":"(+11:00) Asia/Magadan","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Noumea","displayName":"(+11:00) Pacific/Noumea","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Guadalcanal","displayName":"(+11:00) Pacific/Guadalcanal","utcOffsetSeconds":39600},
  
    {"name":"Asia/Srednekolymsk","displayName":"(+11:00) Asia/Srednekolymsk","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Auckland","displayName":"(+13:00) Pacific/Auckland","utcOffsetSeconds":46800},
  
    {"name":"Pacific/Fiji","displayName":"(+12:00) Pacific/Fiji","utcOffsetSeconds":43200},
  
    {"name":"Asia/Kamchatka","displayName":"(+12:00) Asia/Kamchatka","utcOffsetSeconds":43200},
  
    {"name":"Pacific/Majuro","displayName":"(+12:00) Pacific/Majuro","utcOffsetSeconds":43200},
  
    {"name":"Pacific/Chatham","displayName":"(+13:45) Pacific/Chatham","utcOffsetSeconds":49500},
  
    {"name":"Pacific/Tongatapu","displayName":"(+13:00) Pacific/Tongatapu","utcOffsetSeconds":46800},
  
    {"name":"Pacific/Apia","displayName":"(+13:00) Pacific/Apia","utcOffsetSeconds":46800},
  
    {"name":"Pacific/Fakaofo","displayName":"(+13:00) Pacific/Fakaofo","utcOffsetSeconds":46800},
  
];

export const NON_US_TIME_ZONES = [
  
    {"name":"Etc/GMT+12","displayName":"(-12:00) Etc/Gmt+12","utcOffsetSeconds":-43200},
  
    {"name":"Pacific/Pago_Pago","displayName":"(-11:00) Pacific/Pago Pago","utcOffsetSeconds":-39600},
  
    {"name":"Pacific/Midway","displayName":"(-11:00) Pacific/Midway","utcOffsetSeconds":-39600},
  
    {"name":"Pacific/Honolulu","displayName":"(-10:00) Pacific/Honolulu","utcOffsetSeconds":-36000},
  
    {"name":"America/Juneau","displayName":"(-09:00) America/Juneau","utcOffsetSeconds":-32400},
  
    {"name":"America/Tijuana","displayName":"(-08:00) America/Tijuana","utcOffsetSeconds":-28800},
  
    {"name":"America/Mazatlan","displayName":"(-07:00) America/Mazatlan","utcOffsetSeconds":-25200},
  
    {"name":"America/Guatemala","displayName":"(-06:00) America/Guatemala","utcOffsetSeconds":-21600},
  
    {"name":"America/Chihuahua","displayName":"(-06:00) America/Chihuahua","utcOffsetSeconds":-21600},
  
    {"name":"America/Mexico_City","displayName":"(-06:00) America/Mexico City","utcOffsetSeconds":-21600},
  
    {"name":"America/Monterrey","displayName":"(-06:00) America/Monterrey","utcOffsetSeconds":-21600},
  
    {"name":"America/Regina","displayName":"(-06:00) America/Regina","utcOffsetSeconds":-21600},
  
    {"name":"America/Bogota","displayName":"(-05:00) America/Bogota","utcOffsetSeconds":-18000},
  
    {"name":"America/Lima","displayName":"(-05:00) America/Lima","utcOffsetSeconds":-18000},
  
    {"name":"America/Halifax","displayName":"(-04:00) America/Halifax","utcOffsetSeconds":-14400},
  
    {"name":"America/Caracas","displayName":"(-04:00) America/Caracas","utcOffsetSeconds":-14400},
  
    {"name":"America/Guyana","displayName":"(-04:00) America/Guyana","utcOffsetSeconds":-14400},
  
    {"name":"America/La_Paz","displayName":"(-04:00) America/La Paz","utcOffsetSeconds":-14400},
  
    {"name":"America/Puerto_Rico","displayName":"(-04:00) America/Puerto Rico","utcOffsetSeconds":-14400},
  
    {"name":"America/Santiago","displayName":"(-03:00) America/Santiago","utcOffsetSeconds":-10800},
  
    {"name":"America/St_Johns","displayName":"(-03:30) America/St Johns","utcOffsetSeconds":-12600},
  
    {"name":"America/Asuncion","displayName":"(-03:00) America/Asuncion","utcOffsetSeconds":-10800},
  
    {"name":"America/Sao_Paulo","displayName":"(-03:00) America/Sao Paulo","utcOffsetSeconds":-10800},
  
    {"name":"America/Argentina/Buenos_Aires","displayName":"(-03:00) America/Argentina/Buenos Aires","utcOffsetSeconds":-10800},
  
    {"name":"America/Montevideo","displayName":"(-03:00) America/Montevideo","utcOffsetSeconds":-10800},
  
    {"name":"America/Nuuk","displayName":"(-02:00) America/Nuuk","utcOffsetSeconds":-7200},
  
    {"name":"Atlantic/South_Georgia","displayName":"(-02:00) Atlantic/South Georgia","utcOffsetSeconds":-7200},
  
    {"name":"Atlantic/Azores","displayName":"(-01:00) Atlantic/Azores","utcOffsetSeconds":-3600},
  
    {"name":"Atlantic/Cape_Verde","displayName":"(-01:00) Atlantic/Cape Verde","utcOffsetSeconds":-3600},
  
    {"name":"Africa/Casablanca","displayName":"(+00:00) Africa/Casablanca","utcOffsetSeconds":0},
  
    {"name":"Europe/London","displayName":"(+00:00) Europe/London","utcOffsetSeconds":0},
  
    {"name":"Europe/Lisbon","displayName":"(+00:00) Europe/Lisbon","utcOffsetSeconds":0},
  
    {"name":"Africa/Monrovia","displayName":"(+00:00) Africa/Monrovia","utcOffsetSeconds":0},
  
    {"name":"Etc/UTC","displayName":"(+00:00) Etc/Utc","utcOffsetSeconds":0},
  
    {"name":"Europe/Amsterdam","displayName":"(+01:00) Europe/Amsterdam","utcOffsetSeconds":3600},
  
    {"name":"Europe/Belgrade","displayName":"(+01:00) Europe/Belgrade","utcOffsetSeconds":3600},
  
    {"name":"Europe/Berlin","displayName":"(+01:00) Europe/Berlin","utcOffsetSeconds":3600},
  
    {"name":"Europe/Zurich","displayName":"(+01:00) Europe/Zurich","utcOffsetSeconds":3600},
  
    {"name":"Europe/Bratislava","displayName":"(+01:00) Europe/Bratislava","utcOffsetSeconds":3600},
  
    {"name":"Europe/Brussels","displayName":"(+01:00) Europe/Brussels","utcOffsetSeconds":3600},
  
    {"name":"Europe/Budapest","displayName":"(+01:00) Europe/Budapest","utcOffsetSeconds":3600},
  
    {"name":"Europe/Copenhagen","displayName":"(+01:00) Europe/Copenhagen","utcOffsetSeconds":3600},
  
    {"name":"Europe/Dublin","displayName":"(+00:00) Europe/Dublin","utcOffsetSeconds":0},
  
    {"name":"Europe/Ljubljana","displayName":"(+01:00) Europe/Ljubljana","utcOffsetSeconds":3600},
  
    {"name":"Europe/Madrid","displayName":"(+01:00) Europe/Madrid","utcOffsetSeconds":3600},
  
    {"name":"Europe/Paris","displayName":"(+01:00) Europe/Paris","utcOffsetSeconds":3600},
  
    {"name":"Europe/Prague","displayName":"(+01:00) Europe/Prague","utcOffsetSeconds":3600},
  
    {"name":"Europe/Rome","displayName":"(+01:00) Europe/Rome","utcOffsetSeconds":3600},
  
    {"name":"Europe/Sarajevo","displayName":"(+01:00) Europe/Sarajevo","utcOffsetSeconds":3600},
  
    {"name":"Europe/Skopje","displayName":"(+01:00) Europe/Skopje","utcOffsetSeconds":3600},
  
    {"name":"Europe/Stockholm","displayName":"(+01:00) Europe/Stockholm","utcOffsetSeconds":3600},
  
    {"name":"Europe/Vienna","displayName":"(+01:00) Europe/Vienna","utcOffsetSeconds":3600},
  
    {"name":"Europe/Warsaw","displayName":"(+01:00) Europe/Warsaw","utcOffsetSeconds":3600},
  
    {"name":"Africa/Algiers","displayName":"(+01:00) Africa/Algiers","utcOffsetSeconds":3600},
  
    {"name":"Europe/Zagreb","displayName":"(+01:00) Europe/Zagreb","utcOffsetSeconds":3600},
  
    {"name":"Europe/Athens","displayName":"(+02:00) Europe/Athens","utcOffsetSeconds":7200},
  
    {"name":"Europe/Bucharest","displayName":"(+02:00) Europe/Bucharest","utcOffsetSeconds":7200},
  
    {"name":"Africa/Cairo","displayName":"(+02:00) Africa/Cairo","utcOffsetSeconds":7200},
  
    {"name":"Africa/Harare","displayName":"(+02:00) Africa/Harare","utcOffsetSeconds":7200},
  
    {"name":"Europe/Helsinki","displayName":"(+02:00) Europe/Helsinki","utcOffsetSeconds":7200},
  
    {"name":"Asia/Jerusalem","displayName":"(+02:00) Asia/Jerusalem","utcOffsetSeconds":7200},
  
    {"name":"Europe/Kaliningrad","displayName":"(+02:00) Europe/Kaliningrad","utcOffsetSeconds":7200},
  
    {"name":"Europe/Kyiv","displayName":"(+02:00) Europe/Kyiv","utcOffsetSeconds":7200},
  
    {"name":"Africa/Johannesburg","displayName":"(+02:00) Africa/Johannesburg","utcOffsetSeconds":7200},
  
    {"name":"Europe/Riga","displayName":"(+02:00) Europe/Riga","utcOffsetSeconds":7200},
  
    {"name":"Europe/Sofia","displayName":"(+02:00) Europe/Sofia","utcOffsetSeconds":7200},
  
    {"name":"Europe/Tallinn","displayName":"(+02:00) Europe/Tallinn","utcOffsetSeconds":7200},
  
    {"name":"Europe/Vilnius","displayName":"(+02:00) Europe/Vilnius","utcOffsetSeconds":7200},
  
    {"name":"Asia/Baghdad","displayName":"(+03:00) Asia/Baghdad","utcOffsetSeconds":10800},
  
    {"name":"Europe/Istanbul","displayName":"(+03:00) Europe/Istanbul","utcOffsetSeconds":10800},
  
    {"name":"Asia/Kuwait","displayName":"(+03:00) Asia/Kuwait","utcOffsetSeconds":10800},
  
    {"name":"Europe/Minsk","displayName":"(+03:00) Europe/Minsk","utcOffsetSeconds":10800},
  
    {"name":"Europe/Moscow","displayName":"(+03:00) Europe/Moscow","utcOffsetSeconds":10800},
  
    {"name":"Africa/Nairobi","displayName":"(+03:00) Africa/Nairobi","utcOffsetSeconds":10800},
  
    {"name":"Asia/Riyadh","displayName":"(+03:00) Asia/Riyadh","utcOffsetSeconds":10800},
  
    {"name":"Europe/Volgograd","displayName":"(+03:00) Europe/Volgograd","utcOffsetSeconds":10800},
  
    {"name":"Asia/Tehran","displayName":"(+03:30) Asia/Tehran","utcOffsetSeconds":12600},
  
    {"name":"Asia/Muscat","displayName":"(+04:00) Asia/Muscat","utcOffsetSeconds":14400},
  
    {"name":"Asia/Baku","displayName":"(+04:00) Asia/Baku","utcOffsetSeconds":14400},
  
    {"name":"Europe/Samara","displayName":"(+04:00) Europe/Samara","utcOffsetSeconds":14400},
  
    {"name":"Asia/Tbilisi","displayName":"(+04:00) Asia/Tbilisi","utcOffsetSeconds":14400},
  
    {"name":"Asia/Yerevan","displayName":"(+04:00) Asia/Yerevan","utcOffsetSeconds":14400},
  
    {"name":"Asia/Kabul","displayName":"(+04:30) Asia/Kabul","utcOffsetSeconds":16200},
  
    {"name":"Asia/Almaty","displayName":"(+05:00) Asia/Almaty","utcOffsetSeconds":18000},
  
    {"name":"Asia/Yekaterinburg","displayName":"(+05:00) Asia/Yekaterinburg","utcOffsetSeconds":18000},
  
    {"name":"Asia/Karachi","displayName":"(+05:00) Asia/Karachi","utcOffsetSeconds":18000},
  
    {"name":"Asia/Tashkent","displayName":"(+05:00) Asia/Tashkent","utcOffsetSeconds":18000},
  
    {"name":"Asia/Kolkata","displayName":"(+05:30) Asia/Kolkata","utcOffsetSeconds":19800},
  
    {"name":"Asia/Colombo","displayName":"(+05:30) Asia/Colombo","utcOffsetSeconds":19800},
  
    {"name":"Asia/Kathmandu","displayName":"(+05:45) Asia/Kathmandu","utcOffsetSeconds":20700},
  
    {"name":"Asia/Dhaka","displayName":"(+06:00) Asia/Dhaka","utcOffsetSeconds":21600},
  
    {"name":"Asia/Urumqi","displayName":"(+06:00) Asia/Urumqi","utcOffsetSeconds":21600},
  
    {"name":"Asia/Yangon","displayName":"(+06:30) Asia/Yangon","utcOffsetSeconds":23400},
  
    {"name":"Asia/Bangkok","displayName":"(+07:00) Asia/Bangkok","utcOffsetSeconds":25200},
  
    {"name":"Asia/Jakarta","displayName":"(+07:00) Asia/Jakarta","utcOffsetSeconds":25200},
  
    {"name":"Asia/Krasnoyarsk","displayName":"(+07:00) Asia/Krasnoyarsk","utcOffsetSeconds":25200},
  
    {"name":"Asia/Novosibirsk","displayName":"(+07:00) Asia/Novosibirsk","utcOffsetSeconds":25200},
  
    {"name":"Asia/Shanghai","displayName":"(+08:00) Asia/Shanghai","utcOffsetSeconds":28800},
  
    {"name":"Asia/Chongqing","displayName":"(+08:00) Asia/Chongqing","utcOffsetSeconds":28800},
  
    {"name":"Asia/Hong_Kong","displayName":"(+08:00) Asia/Hong Kong","utcOffsetSeconds":28800},
  
    {"name":"Asia/Irkutsk","displayName":"(+08:00) Asia/Irkutsk","utcOffsetSeconds":28800},
  
    {"name":"Asia/Kuala_Lumpur","displayName":"(+08:00) Asia/Kuala Lumpur","utcOffsetSeconds":28800},
  
    {"name":"Australia/Perth","displayName":"(+08:00) Australia/Perth","utcOffsetSeconds":28800},
  
    {"name":"Asia/Singapore","displayName":"(+08:00) Asia/Singapore","utcOffsetSeconds":28800},
  
    {"name":"Asia/Taipei","displayName":"(+08:00) Asia/Taipei","utcOffsetSeconds":28800},
  
    {"name":"Asia/Ulaanbaatar","displayName":"(+08:00) Asia/Ulaanbaatar","utcOffsetSeconds":28800},
  
    {"name":"Asia/Tokyo","displayName":"(+09:00) Asia/Tokyo","utcOffsetSeconds":32400},
  
    {"name":"Asia/Seoul","displayName":"(+09:00) Asia/Seoul","utcOffsetSeconds":32400},
  
    {"name":"Asia/Yakutsk","displayName":"(+09:00) Asia/Yakutsk","utcOffsetSeconds":32400},
  
    {"name":"Australia/Adelaide","displayName":"(+10:30) Australia/Adelaide","utcOffsetSeconds":37800},
  
    {"name":"Australia/Darwin","displayName":"(+09:30) Australia/Darwin","utcOffsetSeconds":34200},
  
    {"name":"Australia/Brisbane","displayName":"(+10:00) Australia/Brisbane","utcOffsetSeconds":36000},
  
    {"name":"Australia/Canberra","displayName":"(+11:00) Australia/Canberra","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Guam","displayName":"(+10:00) Pacific/Guam","utcOffsetSeconds":36000},
  
    {"name":"Australia/Hobart","displayName":"(+11:00) Australia/Hobart","utcOffsetSeconds":39600},
  
    {"name":"Australia/Melbourne","displayName":"(+11:00) Australia/Melbourne","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Port_Moresby","displayName":"(+10:00) Pacific/Port Moresby","utcOffsetSeconds":36000},
  
    {"name":"Australia/Sydney","displayName":"(+11:00) Australia/Sydney","utcOffsetSeconds":39600},
  
    {"name":"Asia/Vladivostok","displayName":"(+10:00) Asia/Vladivostok","utcOffsetSeconds":36000},
  
    {"name":"Asia/Magadan","displayName":"(+11:00) Asia/Magadan","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Noumea","displayName":"(+11:00) Pacific/Noumea","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Guadalcanal","displayName":"(+11:00) Pacific/Guadalcanal","utcOffsetSeconds":39600},
  
    {"name":"Asia/Srednekolymsk","displayName":"(+11:00) Asia/Srednekolymsk","utcOffsetSeconds":39600},
  
    {"name":"Pacific/Auckland","displayName":"(+13:00) Pacific/Auckland","utcOffsetSeconds":46800},
  
    {"name":"Pacific/Fiji","displayName":"(+12:00) Pacific/Fiji","utcOffsetSeconds":43200},
  
    {"name":"Asia/Kamchatka","displayName":"(+12:00) Asia/Kamchatka","utcOffsetSeconds":43200},
  
    {"name":"Pacific/Majuro","displayName":"(+12:00) Pacific/Majuro","utcOffsetSeconds":43200},
  
    {"name":"Pacific/Chatham","displayName":"(+13:45) Pacific/Chatham","utcOffsetSeconds":49500},
  
    {"name":"Pacific/Tongatapu","displayName":"(+13:00) Pacific/Tongatapu","utcOffsetSeconds":46800},
  
    {"name":"Pacific/Apia","displayName":"(+13:00) Pacific/Apia","utcOffsetSeconds":46800},
  
    {"name":"Pacific/Fakaofo","displayName":"(+13:00) Pacific/Fakaofo","utcOffsetSeconds":46800},
  
];

export const US_TIME_ZONES = [
  
    {"name":"America/New_York","displayName":"(-05:00) America/New York","utcOffsetSeconds":-18000},
  
    {"name":"America/Indiana/Indianapolis","displayName":"(-05:00) America/Indiana/Indianapolis","utcOffsetSeconds":-18000},
  
    {"name":"America/Chicago","displayName":"(-06:00) America/Chicago","utcOffsetSeconds":-21600},
  
    {"name":"America/Denver","displayName":"(-07:00) America/Denver","utcOffsetSeconds":-25200},
  
    {"name":"America/Phoenix","displayName":"(-07:00) America/Phoenix","utcOffsetSeconds":-25200},
  
    {"name":"America/Los_Angeles","displayName":"(-08:00) America/Los Angeles","utcOffsetSeconds":-28800},
  
];

export const APP_TIMEZONE = "America/New_York" as const;
